import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { validateLoginToken } from '../../utils/auth';
import { User } from '../../models/User';
import Menu from './Menu';

export const UserContext = React.createContext<User | null>(null);

const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const user = await validateLoginToken();
      setCurrentUser(user);
      setLoading(false);
    };
    checkAuth();
  }, []);

  if (loading) return <div>Loading...</div>;

  return currentUser ? (
    <UserContext.Provider value={currentUser}>
      <Menu />
      {children}
    </UserContext.Provider>
  ) : (
    <Navigate to="/halo/login" state={{ from: location }} replace />
  );
};

export default AdminRoute;